import React from 'react';

import { Button } from '@depop/web-ui-kit/Button';

import { ErrorMessage } from '../ErrorMessage';

type ButtonProps = React.ComponentProps<typeof Button>;

type ErrorButtonProps = {
  errorText?: string;
} & ButtonProps;

function ButtonWithError({ errorText, children, ...rest }: ErrorButtonProps) {
  return (
    <>
      <Button {...rest}>{children}</Button>
      {errorText && <ErrorMessage>{errorText}</ErrorMessage>}
    </>
  );
}

export { ButtonWithError };
